import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=5117f793&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=js"
export * from "./projectDetail.vue?vue&type=script&lang=js"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=5117f793&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117f793",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5117f793')) {
      api.createRecord('5117f793', component.options)
    } else {
      api.reload('5117f793', component.options)
    }
    module.hot.accept("./projectDetail.vue?vue&type=template&id=5117f793&scoped=true", function () {
      api.rerender('5117f793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/projectDetail.vue"
export default component.exports